/**
 * Stats Service - Track game analytics
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.withCredentials = true;

/**
 * Record a completed game result
 */
export async function recordGameResult({
  result,
  difficulty,
  playerColor,
  totalMoves,
  gameDurationSeconds,
  openingName
}) {
  try {
    await axios.post(`${API_URL}/api/stats/record-game`, {
      result, // 'win', 'loss', 'draw'
      opponent_type: 'ai',
      difficulty,
      player_color: playerColor,
      total_moves: totalMoves,
      game_duration_seconds: gameDurationSeconds,
      opening_name: openingName
    }, { withCredentials: true });
    return true;
  } catch (error) {
    console.error('Failed to record game result:', error);
    return false;
  }
}

/**
 * Get player statistics
 */
export async function getPlayerStats() {
  try {
    const { data } = await axios.get(`${API_URL}/api/stats`, {
      withCredentials: true
    });
    return data;
  } catch (error) {
    console.error('Failed to get stats:', error);
    return null;
  }
}

/**
 * Get recent game history
 */
export async function getGameHistory(limit = 20) {
  try {
    const { data } = await axios.get(`${API_URL}/api/stats/history?limit=${limit}`, {
      withCredentials: true
    });
    return data;
  } catch (error) {
    console.error('Failed to get history:', error);
    return [];
  }
}
